import { useState } from "react";
import CustomDialog from "../../../../../../components/Dialog/DiaCompMedium";
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import ReadMoreIcon from '@mui/icons-material/ReadMore';
//import ClockText from "./ClockText";


export default function DiaHeartInfo() {

    const [open, setOpen] = useState(false);
    const handleOpen = () => {setOpen(true);};
    const handleClose = () => {setOpen(false);};
  
    return (
      <>
    
  
        <Tooltip title="Data" placement="right">
            <IconButton onClick={handleOpen} >
                <ReadMoreIcon sx={{ '&:hover': { transform: 'scale(1.1)', color: 'quartiary.main', } }}/>
            </IconButton>   
        </Tooltip>
   
    <CustomDialog open={open} onClose={handleClose}

          title="Cardiovascular heart clock - what is it?"
         
          content = { "" }

        />
        
</>
)}